<div class="component-wrapper">
  <div id="label" [class.invalid]="!valueValid">
    {{label}}
    @if (hasValidtor('require')) {
      <span class="reqIcon" [class.invalid]="!valueValid" id="require" #require> * </span>
    }
    @if (hasValidtor('info')) {
      <mat-icon id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"
        class="infoIcon" [class.invalid]="!valueValid" svgIcon="help.tooltip">
      </mat-icon>
    }
  </div>
  <div class="selectedImageContainer" (insClickOutside)="clickOutside()">
    <div id = "imageBrowser">
      @if (value !== '') {
        <div class="imageContainerContainer">
          <div class="imageContainer">
            <img class="imageToSelect" [src]="getImageResult()" alt="select img icon">
          </div>
          @if (unchangeable) {
            <div class="textButton textButtonInImagePicker" (click)="showSelector = true">Edit Image</div>
          }
        </div>
      } @else {
        <div id="emptyImageContainerContainer">
          <div #iconButton id="emptyImageContainer" (click)="openSelector(iconButton)">
            <mat-icon svgIcon="input-file.browse" ></mat-icon>
          </div>
          <div id="nonValidIconContainer">
            @if (!valueValid) {
              <mat-icon class="warningIcon" svgIcon="warning"
                insTooltip [cfg]="{text: getValidtor('input').displayText, position: {H: 'hRight', V:'vBottom'}, type: 'err'}">
              </mat-icon>
            }
          </div>
        </div>
      }
    </div>
    @if (showSelector) {
      <div class="imageSelector" [ngStyle]="selectorPosition">
        <div class="knownImages">
          @for (image of imagesList; track image) {
            <div class="imageToSelectContainer"
              (click)="onImagePicked(libIconSrv.getIdByName(image))"
              (contextmenu)="onImageRightClick($event, image)">
              <img class="imageToSelect" [src]="libIconSrv.getLibIconUrlForDialog(libIconSrv.getIdByName(image))" alt="img select icon">
            </div>
          }
        </div>
        <div style="padding:4px">
          <ins-input-file [label]="" [showWithImageSelector]="false" [buttonText]="'...'" [fileType]="'.png,.jpg,.gif'"
            (valueChange)="selectExternalImage($event)" (isValid)="stateIfValid($event)" [validatorCfg]="fileTypeValidator"
            [placeholder]="'Select file'"
          [triggerValidityOnlyInChange]="false" [triggerValueChangeAfterValidity]="true"></ins-input-file>
        </div>
      </div>
    }
  </div>

  @if (showCopyIconContextMenu) {
    <div class="context-menu" [ngStyle]="copyIconContextMenuPosition" (insClickOutside)="onContextMenuClickOutside()">
      <div class="context-menu-item" (click)="copyIconName()"(keydown)="null">Copy Icon Name</div>
    </div>
  }

</div>

